import React from 'react';
import styled from 'styled-components';
import logoImage from '../assets/images/logo.png';
import theme from '../styles/theme/index';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImg = styled.img`
  height: ${theme.images.sizes.logo};
  width: auto;
`;

export const Logo = () => {
  return (
    <LogoContainer>
      <LogoImg src={logoImage} alt="Planet Protection" />
    </LogoContainer>
  );
}; 